
class EmailField extends React.Component {
  render () {
    let {input, meta, type, placeholder, maxLength} = this.props
    let {touched, error} = meta
    return (
      <div className='form-group'>
        <input {...input} type={type} maxLength={maxLength} placeholder={placeholder} className='form-control' />
        <small className='error'>{touched ? error : ''}</small>
      </div>
    )
  }
}

EmailField.propTypes = {
}

export default EmailField



// WEBPACK FOOTER //
// ./app/components/receipt/transactions/ResendEmailModal/EmailField.js